import React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import { firstError } from 'common/validation';
import { SHOW_CANCEL_SUBMISSION_DIALOG } from 'submission/submissionActions';
import { getStep } from 'common/selectors';
import * as steps from 'common/steps';
import { RadioGroup, RadioButton } from 'react-toolbox/lib/radio';
import LoadingPanel from 'general-components/LoadingPanel';
import StepPanelButtonBar from 'general-components/StepPanelButtonBar';
import OptIn from './OptIn';
import OptInTermsDialog from './OptInTermsDialog';
import styles from './Options.css';

import {
  COMPLETE_STEP,
  DECLINE_OPT_IN,
  EMBARGO_PERIOD_CHANGED,
  UNDO_OPT_IN,
  VIEW_OPT_IN_TERMS,
} from 'options/optionsActions';

import { getErrors, getFields, getLoading } from 'common/stepReducerUtil';

import {
  EMBARGO_PERIOD_NONE,
  EMBARGO_PERIOD_SIX_MONTHS,
  EMBARGO_PERIOD_ONE_YEAR,
  EMBARGO_PERIOD_TWO_YEARS,
  getAcceptedOptIns,
  getDeclinedOptIns,
  getOptIns,
} from 'options/optionsReducer';

const Options = ({
  acceptedOptIns,
  declinedOptIns,
  errors,
  fields,
  loading,
  onCancel,
  onDeclineOptIn,
  onEmbargoPeriodChanged,
  onNext,
  onUndoOptIn,
  onViewOptInTerms,
  optIns,
}) =>
  loading
    ? <LoadingPanel />
    : <div className={styles.stepPanel}>
        <h1>Options & Terms</h1>
        {R.addIndex(R.map)(
          (optIn, index) =>
            <OptIn
              accepted={R.contains(optIn.optInId, acceptedOptIns)}
              declined={R.contains(optIn.optInId, declinedOptIns)}
              error={firstError(errors, `optIns[${index}]`)}
              key={optIn.optInTitle}
              onAccept={() => onViewOptInTerms(optIn.optInId)}
              onDecline={() => onDeclineOptIn(optIn.optInId)}
              onUndo={() => onUndoOptIn(optIn.optInId)}
              optIn={optIn}
            />,
          optIns,
        )}
        <h2>Delay the release of my dissertation</h2>

        <RadioGroup
          value={fields.embargoPeriod}
          onChange={onEmbargoPeriodChanged}
        >
          <RadioButton
            label="Don't delay, release my work as soon as possible."
            value={EMBARGO_PERIOD_NONE}
          />
          <RadioButton
            label="Delay releasing my work for 6 months."
            value={EMBARGO_PERIOD_SIX_MONTHS}
          />
          <RadioButton
            label="Delay releasing my work for 1 year."
            value={EMBARGO_PERIOD_ONE_YEAR}
          />
          <RadioButton
            label="Delay releasing my work for 2 years."
            value={EMBARGO_PERIOD_TWO_YEARS}
          />
        </RadioGroup>
        <OptInTermsDialog />
        <StepPanelButtonBar onNext={onNext} onCancel={onCancel} />
      </div>;

const mapState = R.pipe(
  getStep(steps.OPTIONS),
  R.applySpec({
    acceptedOptIns: getAcceptedOptIns,
    declinedOptIns: getDeclinedOptIns,
    errors: getErrors,
    fields: getFields,
    loading: getLoading,
    optIns: getOptIns,
  }),
);

const mapDispatch = dispatch => ({
  onViewOptInTerms: id => dispatch({ type: VIEW_OPT_IN_TERMS, id }),
  onCancel: () => dispatch({ type: SHOW_CANCEL_SUBMISSION_DIALOG, show: true }),
  onDeclineOptIn: id => dispatch({ type: DECLINE_OPT_IN, id }),
  onEmbargoPeriodChanged: embargoPeriod =>
    dispatch({ type: EMBARGO_PERIOD_CHANGED, embargoPeriod }),
  onNext: () => dispatch({ type: COMPLETE_STEP }),
  onUndoOptIn: id => dispatch({ type: UNDO_OPT_IN, id }),
});

export default connect(mapState, mapDispatch)(Options);



// WEBPACK FOOTER //
// ./src/options/components/Options.js